import React, {useEffect, useState} from "react";
import styles from './index.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faChevronRight} from "@fortawesome/free-solid-svg-icons";


function Page({index, currentPage, setCurrentPage, maxPages}) {
    if(Math.abs(index - currentPage) - Math.floor(maxPages / 2) > 1) return null;

    const half = Math.floor(maxPages / 2);
    const isEllipsis = Math.abs(index - currentPage) - half === 1;
    const isActive = currentPage === index && !isEllipsis;

    return (
        <button
            type="button"
            disabled={isEllipsis}
            aria-label={isEllipsis ? undefined : `Ir a página ${index}`}
            aria-current={isActive ? 'page' : undefined}
            className={`${styles.page} ${isActive ? styles.pageActive : ''} ${isEllipsis ? styles.pageEllipsis : ''}`}
            onClick={() => {
                if(Math.abs(index - currentPage) - Math.floor(maxPages / 2) !== 1) setCurrentPage(index);
            }}>
            {isEllipsis ?
                <span aria-hidden>{'…'}</span>
                :
                index
            }
        </button>
    );
}

export default function Pagination({
    count,
    arrows = false,
    color = '#4A4DBB',
    maxPages = 6,
    onInput,
    style,
    className,
    currentPage: controlledPage,
}) {
    const [internalCurrentPage, setCurrentPage] = useState(1);
    const [firstRender, setFirstRender] = useState(true);

    useEffect(() => {
        if(!controlledPage || controlledPage === internalCurrentPage) return;
        setCurrentPage(controlledPage);
    }, [controlledPage]);

    useEffect(() => {
        if(firstRender) {
            setFirstRender(false);
            return;
        }
        if(onInput) onInput(internalCurrentPage);
    }, [internalCurrentPage]);

    const rootStyle = {
        ...style,
        '--pagination-accent': color,
    };

    return (
        <nav
            className={`${styles.paginationRoot} ${className || ''}`}
            style={rootStyle}
            aria-label={'Paginación'}
        >
            {arrows && (
                <button
                    type="button"
                    className={styles.arrowBtn}
                    disabled={internalCurrentPage <= 1}
                    aria-label={'Página anterior'}
                    onClick={() => setCurrentPage((page) => page - 1)}
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
            )}

            <div className={styles.pageGroup}>
                {Array.from({length: count}).map((_, i) => (
                    <Page
                        maxPages={maxPages}
                        currentPage={internalCurrentPage}
                        index={i + 1}
                        key={i}
                        setCurrentPage={setCurrentPage}
                    />
                ))}
            </div>

            {arrows && (
                <button
                    type="button"
                    className={styles.arrowBtn}
                    disabled={internalCurrentPage >= count}
                    aria-label={'Página siguiente'}
                    onClick={() => setCurrentPage((page) => page + 1)}
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            )}
        </nav>
    );
}
